(() => {
  const g = window;
  if (g.GlossaryCore) return;

  const parseTags = (raw) => {
    if (!raw) return [];
    try {
      const j = JSON.parse(raw);
      if (Array.isArray(j)) return j.map(t => String(t).toLowerCase().trim()).filter(Boolean);
    } catch (e) {}
    return String(raw).split(',').map(t => t.toLowerCase().trim()).filter(Boolean);
  };

  const fieldsToMap = (fields) => Object.fromEntries((fields || []).map(f => [f.key, f]));

  const sfFetch = async ({ endpoint, token, query, variables }) => {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query, variables })
    });

    let json = null;
    try { json = await res.json(); } catch (e) {}

    if (!res.ok) {
      const msg = json?.errors?.[0]?.message || `HTTP ${res.status}`;
      throw new Error(msg);
    }

    if (json?.errors?.length) {
      throw new Error(json.errors[0].message || 'GraphQL error');
    }

    return json;
  };

  const METAOBJECTS_QUERY = `
    query ($type: String!, $first: Int!, $after: String) {
      metaobjects(type: $type, first: $first, after: $after) {
        edges {
          node {
            handle
            fields {
              key
              value
              reference {
                __typename
                ... on MediaImage { image { url altText } }
                ... on Collection { handle }
              }
            }
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }
  `;

  g.GlossaryCore = {
    parseTags,
    fieldsToMap,
    sfFetch,
    METAOBJECTS_QUERY
  };
})();
